/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 481);
/******/ })
/************************************************************************/
/******/ ({

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var prayer = $('.prayer');
var enrollment = $('.enrollment');
var customAmount = $('span.ginput_product_price + input:hidden');
var customAmountLabel = $('span.ginput_product_price');

$(prayer).hide();
$(enrollment).hide();

$('input:radio[name="input_9"]').click(function () {
	var donationAmount = $(this).val();

	if (donationAmount == '$0') {
		$(prayer).hide();
		$(enrollment).hide();
	} else if (donationAmount == '$5') {
		$(prayer).show();
		$(enrollment).hide();
		$(customAmountLabel).text(donationAmount);
		$(customAmount).val(donationAmount);
	} else if (donationAmount == '$10') {

		$(prayer).hide();
		$(enrollment).show();
		$(customAmountLabel).text(donationAmount);
		$(customAmount).val(donationAmount);
	} else if (donationAmount == 'Other') {
		prayer.hide();
		enrollment.hide();

		$('#input_5_36').on('keyup', function () {
			this.value = this.value.replace(/[^0-9.]/g, '');
			var otherAmount = $(this).val();
			var value = parseFloat(otherAmount);

			if (otherAmount <= 4) {
				$(prayer).hide();
				$(enrollment).hide();
			} else if (otherAmount >= 10) {
				$(prayer).hide();
				$(enrollment).show();
			} else if (otherAmount >= 5) {
				$(prayer).show();
				$(enrollment).hide();
			} else {
				$(prayer).hide();
				$(enrollment).hide();
			}

			$(customAmountLabel).text('$' + value);
			$(customAmount).val(value);
		});
	} else {
		alert('You must enter an amount.');
	}
});

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.prayer-card-scripts.js